// extracted by mini-css-extract-plugin
export default {"active":"CustomNavLink_active__rX6SE","active-closed":"CustomNavLink_active-closed__oCmwe"};